<script setup lang="tsx">
import { getCSSVar } from "@zyzgroup/core-web";

const props = withDefaults(
  defineProps<{
    width?: string;
    height?: string;
    color?: string;
  }>(),
  {
    width: "24px",
    color: getCSSVar("--xg-red")
  }
);
</script>

<template>
  <svg
    viewBox="0 0 24 24"
    :width="props.width"
    :height="props.height ?? props.width"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style="transform-origin: center"
  >
    <path
      d="M12 19.5C7.85786 19.5 4.5 16.1421 4.5 12C4.5 7.85786 7.85786 4.5 12 4.5C16.1421 4.5 19.5 7.85786 19.5 12C19.5 16.1421 16.1421 19.5 12 19.5Z"
      :fill="props.color"
      :stroke="props.color"
    />
    <path
      d="M12.1159 8C12.8297 8 13.4036 8.19414 13.8377 8.58242C14.2792 8.96337 14.5 9.48718 14.5 10.1538C14.5 10.6886 14.3602 11.1355 14.0806 11.4945C13.9849 11.6117 13.6759 11.8974 13.1534 12.3516C12.9474 12.5201 12.7929 12.7106 12.6898 12.9231C12.5721 13.1355 12.5132 13.3773 12.5132 13.6484V13.8352H11.3322V13.6484C11.3322 13.2234 11.4058 12.8755 11.553 12.6044C11.6928 12.3114 12.1085 11.8571 12.8002 11.2418L12.9879 11.033C13.1939 10.7692 13.2969 10.5018 13.2969 10.2308C13.2969 9.85714 13.1902 9.55678 12.9768 9.32967C12.7561 9.10989 12.4433 9 12.0386 9C11.5383 9 11.1777 9.15751 10.957 9.47253C10.7583 9.73626 10.6589 10.1099 10.6589 10.5934H9.5C9.5 9.79487 9.73179 9.16484 10.1954 8.7033C10.6589 8.23443 11.2991 8 12.1159 8ZM11.9172 14.4286C12.16 14.4286 12.355 14.5018 12.5022 14.6484C12.6567 14.7875 12.734 14.9744 12.734 15.2088C12.734 15.4286 12.6531 15.619 12.4912 15.7802C12.3293 15.9267 12.138 16 11.9172 16C11.6891 16 11.4978 15.9231 11.3433 15.7692C11.1887 15.6154 11.1115 15.4286 11.1115 15.2088C11.1115 14.9744 11.1887 14.7875 11.3433 14.6484C11.4904 14.5018 11.6818 14.4286 11.9172 14.4286Z"
      fill="white"
    />
  </svg>
</template>
